import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { useReporting } from "render/hooks/useReporting";

export function useCompleteVisitMutation() {
  const apiClient = useAPIClient();
  const { logError } = useReporting();

  return useMutation({
    mutationFn({ patientId, visitId }: { patientId: string; visitId: string }) {
      return apiClient.visit.completeVisit({ patientId, visitId }).result;
    },
    onError: (error) => logError(`Failed to complete visit: ${error}`),
  });
}
